import React from 'react'
import ReactDOM from 'react-dom'

// Import CSS
import './index.css'

// Import theming
import theme from './theme'
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider'

// Import theming
import App from './App'

import registerServiceWorker from './registerServiceWorker'

ReactDOM.render((
  <MuiThemeProvider theme={theme}>
    <App />
  </MuiThemeProvider>
), document.getElementById('root'))

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js